import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthImaage from "../../assets/images/authbanner.png";
import { useForm, SubmitHandler } from "react-hook-form";
import { AuthModal, ButtonLarge, emailValidator, FormHookInput, Loader, passwordValidator } from "@thdinc/hpf-shared";
import { useAppDispatch } from "@/hooks/hook";
import { registerUser } from "@/redux/slices/userSlice";
import Alert from "@/components/alert/Alert";
import useLoading from "@/hooks/useLoading";

export const SignUp = () => {
  const { isLoading, startLoading, stopLoading } = useLoading();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  type Inputs = {
    email: string;
    password: string;
    confirmPassword: string;
    image: string;
  };
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isSubmitSuccessful },
  } = useForm<Inputs>();
  const password = watch("password");
  const isStrong = password?.length >= 8 ? true : false;

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      startLoading();
      await dispatch(registerUser(data)).unwrap();
      Alert({ message: "User created", type: "success" });
      navigate("/login");
      reset();
    } catch (error) {
      Alert({ message: "User with this email already exists", type: "error" });
      console.log(error);
    } finally {
      stopLoading();
    }
  };

  return (
    <div className="container mx-auto h-screen relative">
      <div className="flex flex-col justify-center min-h-full ">
        <div className="flex justify-center">
          <img className="w-[500px] hidden lg:block rounded-3xl" src={AuthImaage} alt="" />
          <div className="flex flex-col justify-center lg:-ml-11">
            <AuthModal>
              <div className="text-center">
                <p className="text-2xl font-bold ">Signup</p>
                <p className=" my-4">
                  Welcome! Enter your email and password to register.
                </p>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <div className=" font-semibold my-2">Email</div>
                  <FormHookInput
                    type="email"
                    placeholder="Email"
                    register={register("email", {
                      required: "Email is required!",
                      pattern: emailValidator,
                    })}
                    error={errors.email}
                  />
                </div>
                <div className="mt-8">
                  <div className=" font-semibold my-2">Password</div>
                  <FormHookInput
                    type="password"
                    placeholder="Password"
                    register={register("password", {
                      required: "Password is required",
                      pattern: passwordValidator,
                    })}
                    error={errors.password}
                  />
                </div>
                <div className="mt-8">
                  <div className=" font-semibold my-2">Confirm Password</div>
                  <FormHookInput
                    type="password"
                    placeholder="Confirm Password"
                    register={register("confirmPassword", {
                      validate: (value) =>
                        value === password || "The passwords do not match!",
                      required: "Confirm Password is required",
                      // pattern: passwordValidator
                    })}
                    error={errors.confirmPassword}
                  />
                </div>

                <div className="flex gap-1 mt-4 items-center ">
                  <div
                    className={
                      isStrong
                        ? "bg-lime-100 w-14  h-2 rounded-md"
                        : "bg-slate-300 w-14  h-2 rounded-md"
                    }
                  ></div>
                  <div
                    className={
                      isStrong
                        ? "bg-lime-100 w-14  h-2 rounded-md"
                        : "bg-slate-300 w-14  h-2 rounded-md"
                    }
                  ></div>

                  {isStrong && (
                    <>
                      <div className="bg-lime-300 w-14  h-2 rounded-md"></div>
                      <div className="bg-lime-400 w-14  h-2 rounded-md"></div>
                    </>
                  )}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className={
                      isStrong
                        ? "w-5 h-5 text-lime-500"
                        : "w-5 h-5 text-slate-400"
                    }
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  <p
                    className={
                      isStrong
                        ? "text-lime-500 text-sm"
                        : "text-sm text-slate-400"
                    }
                  >
                    {isStrong ? "Strong" : "Weak"}
                  </p>
                </div>

                <div className="mt-8">
                  <ButtonLarge  classes="min-w-full" type="submit">{isLoading ? <Loader /> : 'Signup'}</ButtonLarge>
                </div>
                <div className="text-center mt-4">
                  <Link to="/login" className="text-primary-red  ">
                    Or Login
                  </Link>
                </div>
              </form>
            </AuthModal>
          </div>
        </div>
      </div>
    </div>
  );
};
